const hourMinuteString = (hours: number, minutes: number): string => {
  let duration = '';
  duration += hours ? `${hours.toString()}h` : '';
  // space between hours and minutes
  duration += hours && minutes ? ' ' : '';
  duration += minutes ? `${Math.round(minutes).toString().padStart(2, '0')}m` : '';
  return duration;
};
export default hourMinuteString;
